import { useState } from 'react';
import { X, Send, Calendar, Clock, MapPin, Users, Phone, Mail, MessageSquare } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { toast } from 'sonner';

export const QuoteRequestModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    eventType: '',
    date: '',
    passengers: '',
    details: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Send WhatsApp message with quote details
    const phoneNumber = "33753202093";
    const message = `
🚗 DEMANDE DE DEVIS - YOUMI GREEN VTC

👤 Nom: ${formData.name}
📧 Email: ${formData.email}
📱 Téléphone: ${formData.phone}

📋 Type: ${formData.eventType}
📅 Date: ${formData.date}
👥 Passagers: ${formData.passengers}

📝 Détails:
${formData.details}
    `.trim();
    
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    
    // Open WhatsApp
    window.open(whatsappUrl, '_blank');
    
    toast.success('Demande envoyée ! Nous vous répondrons rapidement.');
    setLoading(false);
    onClose();
    setFormData({
      name: '',
      email: '',
      phone: '',
      eventType: '',
      date: '',
      passengers: '',
      details: ''
    });
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-zinc-900 border-zinc-700 text-white max-w-lg max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold font-['Outfit'] flex items-center gap-3">
            <MessageSquare className="w-6 h-6 text-emerald-500" />
            Demande de devis
          </DialogTitle>
        </DialogHeader>

        <p className="text-zinc-400 text-sm mb-4">
          Événements, mise à disposition, courses longue distance... Décrivez votre besoin et nous vous répondrons rapidement.
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className="text-zinc-300">Nom complet</Label>
              <Input
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Jean Dupont"
                required
                className="bg-zinc-800 border-zinc-700 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-zinc-300">Téléphone</Label>
              <Input
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="06 12 34 56 78"
                required
                className="bg-zinc-800 border-zinc-700 text-white"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label className="text-zinc-300">Email</Label>
            <Input
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="vous@exemple.com"
              required
              className="bg-zinc-800 border-zinc-700 text-white"
            />
          </div>

          <div className="space-y-2">
            <Label className="text-zinc-300">Type de prestation</Label>
            <select
              name="eventType"
              value={formData.eventType}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 bg-zinc-800 border border-zinc-700 rounded-lg text-white"
            >
              <option value="">Sélectionnez...</option>
              <option value="event">Événement (mariage, soirée...)</option>
              <option value="hourly">Mise à disposition horaire</option>
              <option value="longdistance">Course longue distance</option>
              <option value="business">Déplacement professionnel</option>
              <option value="airport_group">Groupe aéroport</option>
              <option value="other">Autre demande</option>
            </select>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label className="text-zinc-300">Date souhaitée</Label>
              <Input
                name="date"
                type="date"
                value={formData.date}
                onChange={handleChange}
                required
                className="bg-zinc-800 border-zinc-700 text-white"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-zinc-300">Nombre de passagers</Label>
              <Input
                name="passengers"
                type="number"
                min="1"
                max="10"
                value={formData.passengers}
                onChange={handleChange}
                placeholder="4"
                required
                className="bg-zinc-800 border-zinc-700 text-white"
              />
            </div>
          </div>

          <div className="space-y-2">
            <Label className="text-zinc-300">Détails de votre demande</Label>
            <Textarea
              name="details"
              value={formData.details}
              onChange={handleChange}
              placeholder="Décrivez votre besoin : lieux, horaires, durée estimée..."
              rows={4}
              required
              className="bg-zinc-800 border-zinc-700 text-white resize-none"
            />
          </div>

          <Button
            type="submit"
            className="w-full btn-primary"
            disabled={loading}
          >
            {loading ? (
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 border-2 border-black border-t-transparent rounded-full animate-spin" />
                Envoi...
              </span>
            ) : (
              <>
                <Send className="w-4 h-4 mr-2" />
                Envoyer la demande
              </>
            )}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
